import { Close, Folder } from '@mui/icons-material';
import { Box, Button, Divider, Grid, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const TotalSocios = ({ datos, setDatos, errores }) => {
    const [galeriaSocios, setGaleriaSocios] = useState(datos.galeria_socios.length > 0 ? datos.galeria_socios : []);
    const removeImg = (index) => {
        setGaleriaSocios(prevGaleria => {
            let newGal = [...prevGaleria];
            newGal = newGal.filter((img, i) => i !== index);
            return newGal;
        });
    }
    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                setGaleriaSocios(prevGaleria => [...prevGaleria, imagen]);
            }
            reader.readAsDataURL(imagen);
        }
    }

    useEffect(() => {
        setDatos({ target: { name: "galeria_socios", value: galeriaSocios } });
    }, [galeriaSocios]);

    return (
        <Box sx={{ mb: { xs: 10, lg: 0 } }}>
            <Grid container spacing={2}>
                <Grid item lg={12} xl>
                    <Typography variant="h6" sx={{ mb: 2 }}>Socios por género</Typography>
                    <Grid container spacing={2}>
                        <Grid item lg={6} xs={12}>
                            <TextField onChange={setDatos} value={datos.cant_socios_hombres} name="cant_socios_hombres" fullWidth type="number" label="Cant. socios hombres" required />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <TextField onChange={setDatos} value={datos.cant_socios_mujeres} name="cant_socios_mujeres" fullWidth type="number" label="Cant. socios mujeres" required />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item lg={12} xl={8}>
                    <Grid container spacing={2} sx={{ xl: { mx: 1 } }}>
                        <Grid item lg={12}>
                            <Typography variant="h6">Total de Empleados</Typography>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <TextField onChange={setDatos} value={datos.cant_empleados_operarios} name="cant_empleados_operarios" fullWidth type="number" label="Cant. operarios" required />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <TextField onChange={setDatos} value={datos.cant_empleados_tecnicos} name="cant_empleados_tecnicos" fullWidth type="number" label="Cant. técnicos" required />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <TextField onChange={setDatos} value={datos.cant_empleados_administrativos} name="cant_empleados_administrativos" fullWidth type="number" label="Cant. administrativos" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item lg={12}>
                    <Typography variant="h6">Fotogalería de Socios y/o Personal de la empresa</Typography>
                    <Typography>(Máximo 3 fotografías)</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        {galeriaSocios.map((image, i) => (
                            <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(i)}>
                                    <Close />
                                </IconButton>
                                <img src={image.dataurl} alt={image.name} width="150px" />
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{ my: 2, display: 'flex', }}>
                        <Button disabled={galeriaSocios.length > 2} component="label" variant="contained" startIcon={<Folder />}>
                            Agregar <input name={`galeria_socios`} onInputCapture={(e) => handleInput(e)} type="file" accept='image/*' hidden />
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default TotalSocios